const INTERACTIVE_SELECTOR = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "[role='button']",
  "[role='link']",
  "[role='menuitem']",
  "[role='checkbox']",
  "[role='switch']",
  "[role='combobox']",
  "[data-row-ignore]",
].join(", ");

/** True when the click landed on a control that should keep its own behavior. */
export function clickTargetSkipsRowNavigation(target: EventTarget | null): boolean {
  const element =
    target instanceof Element
      ? target
      : target instanceof Node
        ? target.parentElement
        : null;
  if (!element) return true;
  return Boolean(element.closest(INTERACTIVE_SELECTOR));
}
